import React from 'react';
import loadable from '@loadable/component';

import CCMilaWithBoxPng01 from '../../../assets/images/products/CC-mila-with-box.png';
import CCMilaWithBoxWebp01 from '../../../assets/images/products/CC-mila-with-box.png?=webp';

const ImageLoader = loadable(() => import('../common/ImageLoader'));
const OrderCard = loadable(() => import('./OrderCard'));

const ProductOrderAlt = ({ localization, type }) => (
  <div
    className='product-order product-order--alt'
    style={{ '--primary-color': ' #F42C52', '--secondary-color': '#FFF2F5' }}
  >
    <div className='product-order__card'>
      <div className='container container--md'>
        <div className='product-order__grid'>
          <div className='product-order__content'>
            <div className='product-order__content-inner'>
              <h2 className='product-order__title'>
                Put Mila to
                <br />
                work for you.
              </h2>
              <div className='product-order__description'>
                <p>
                  She’s backed by a 30-day, no-questions-asked guarantee. You’ve
                  got nothing to lose but crappy air. Order your Mila today.
                </p>
              </div>
            </div>
            <ImageLoader
              className='product-order__image img-relative'
              placeholderAspectRatio={739 / 580}
              image={CCMilaWithBoxPng01}
              webp={CCMilaWithBoxWebp01}
              alt='The Critter Cuddler Mila'
            />
          </div>
          <OrderCard type={type} localization={localization} />
        </div>
      </div>
    </div>
  </div>
);

export default ProductOrderAlt;
